import { importLibrary, setOptions } from '@googlemaps/js-api-loader'
import React, { useEffect, useState } from 'react'

import type { FC } from 'react'

export const PlacesLoader: FC<{ children: React.ReactNode }> = ({ children }) => {
	const [loaded, setLoaded] = useState(false)

	useEffect(() => {
		if (loaded) return

		// Set global options for the Google Maps API
		setOptions({
			key: import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
			v: 'beta',
		})

		// Import the places library
		importLibrary('places').then(() => {
			setLoaded(true)
		}).catch((error) => {
			console.error('Error loading Google Places library:', error)
		})
	}, [loaded])

	if (!loaded) {
		return null
	}

	return <>{children}</>
}
